// 宮崎県の文化と伝統に関する四択問題100問 - 10問1セット×10セット

export const quizSets = [
  {
    id: 1,
    title: "セット1: 神楽の世界（基礎）",
    category: "神楽",
    questions: [
      {
        id: 1,
        question: "宮崎県の神楽は、地理的・季節的特徴によって大きく二つに分類される。県北部・西部の山間部で行われる神楽の総称として、最も適切なものはどれか。",
        options: [
          "夏神楽・半夜神楽",
          "春神楽・昼神楽",
          "秋神楽・宵神楽",
          "冬神楽・夜神楽"
        ],
        correctAnswer: 3,
        explanation: "県北部・西部の山間部では、焼畑農業の収穫感謝祭として冬に行われる「冬神楽」が中心で、夕方から翌朝まで続くため「夜神楽」とも呼ばれます。"
      },
      {
        id: 2,
        question: "県北部の夜神楽が、夕方から翌朝まで夜を徹して行われる主な理由として、歴史的にどのような背景が考えられるか。",
        options: [
          "海上安全と大漁を祈願するため",
          "焼畑農業における収穫感謝と、農閑期の共同体的儀礼のため",
          "藩主の長寿を祝い、武運長久を祈るため",
          "疫病の流行を防ぐための、大規模な祓えの儀式として"
        ],
        correctAnswer: 1,
        explanation: "かつて県北部の山間地域では焼畑が行われており、冬季にヒエやアワなどの収穫を感謝する神楽が奉納されました。労働から解放される冬の農閑期に、夜を徹して行われる儀式は、共同体の結束を強める重要な役割を果たしました。"
      },
      {
        id: 3,
        question: "国の重要無形民俗文化財に指定されている「高千穂の夜神楽」は、ある特定の信仰の影響を古くから強く受けているとされる。その信仰とは何か。",
        options: [
          "富士信仰",
          "熊野信仰",
          "白山信仰",
          "伊勢信仰"
        ],
        correctAnswer: 1,
        explanation: "高千穂の神楽は、古くに紀伊（現在の和歌山県）の熊野信仰の影響を強く受けたとされます。高千穂各地に熊野神社が勧請され、神楽が奉納されるようになった歴史的背景があります。"
      },
      {
        id: 4,
        question: "高千穂神楽の原型と言われ、猪を前に奉納される舞の名称は何か。",
        options: [
          "笹ふり神楽",
          "魚釣舞",
          "十二人剱",
          "奉者舞"
        ],
        correctAnswer: 0,
        explanation: "高千穂の掛け祭りの中で、奉納された猪を前にして舞われる「笹ふり神楽」が、高千穂神楽の原型と言われています。"
      },
      {
        id: 5,
        question: "高千穂の夜神楽は、全体で何番の演目で構成されているか。",
        options: [
          "十二番",
          "二十四番",
          "三十三番",
          "四十八番"
        ],
        correctAnswer: 2,
        explanation: "高千穂の夜神楽は、神々を招き、もてなし、そして送り帰すまでの一連の物語として、三十三番の演目で構成されています。"
      },
      {
        id: 6,
        question: "高千穂の夜神楽において、猿田彦命が神庭を祓い清める序曲の舞を何と呼ぶか。",
        options: [
          "太殿（たいどの）",
          "鎮守（ちんじゅ）",
          "彦舞（ひこまい）",
          "神降（かみおろし）"
        ],
        correctAnswer: 2,
        explanation: "彦舞は、天孫降臨の際に道案内をしたとされる猿田彦命が、神楽の始まりに際して神庭（舞の場）を祓い清め、神々を案内するための序曲の舞です。"
      },
      {
        id: 7,
        question: "「彦舞」で猿田彦命が乗り、四方拝を行う一斗枡は、神話における何を象徴しているか。",
        options: [
          "豊葦原千五百秋瑞穂国",
          "天の岩戸",
          "天の浮橋",
          "八尋殿"
        ],
        correctAnswer: 2,
        explanation: "彦舞で使われる一斗枡は、天と地をつなぐ「天の浮橋」に見立てられています。その上に乗って四方を拝む所作は、国土や村を象徴する場を清める意味を持ちます。"
      },
      {
        id: 8,
        question: "高千穂の夜神楽のクライマックスを飾り、天照大神が岩戸から現れる神話の場面を再現する一連の演目を総称して何と呼ぶか。",
        options: [
          "御神体（ごしんたい）",
          "岩戸開き（いわとびらき）",
          "式三番（しきさんばん）",
          "山森（やまもり）"
        ],
        correctAnswer: 1,
        explanation: "高千穂神楽で最も重要な演目群であり、天照大神が天の岩戸に隠れた神話を再現します。手力雄命、天鈿女命、戸取命などが次々と登場し、夜明けと共にクライマックスを迎えます。"
      },
      {
        id: 9,
        question: "岩戸開きの場面で、岩戸をこじ開ける怪力無双の神として舞うのは誰か。",
        options: [
          "猿田彦命",
          "手力雄命（たぢからおのみこと）",
          "天忍穂耳命（あめのおしほみみのみこと）",
          "句句廼智命（くくのちのみこと）"
        ],
        correctAnswer: 1,
        explanation: "天の岩戸の前で天鈿女命が舞い、神々が笑うと、何事かと岩戸を少し開けた天照大神の手を取り、岩戸をこじ開けたのが怪力の神、手力雄命です。"
      },
      {
        id: 10,
        question: "高千穂の夜神楽において、神楽宿に神々を招き入れる「神降」、神々の鎮座と集落の守護を祈る「鎮守」、そして神を送る「杉登」の三番を合わせて何と呼ぶか。",
        options: [
          "序の舞三番",
          "祓いの三番",
          "鎮めの三番",
          "式三番"
        ],
        correctAnswer: 3,
        explanation: "「神降」「鎮守」「杉登」の三番は、神楽の儀式の中でも特に重要とされ、「式三番」と呼ばれます。祭典では必ず舞われる、神楽の根幹をなす演目です。"
      }
    ]
  },
  {
    id: 2,
    title: "セット2: 神楽の世界（湯立・銀鏡・潮嶽）",
    category: "神楽",
    questions: [
      {
        id: 11,
        question: "宮崎県の神楽で見られる、釜で湯を沸かし、その湯を振りかけて穢れを祓う儀式を何というか。",
        options: [
          "湯立（ゆたて）",
          "禊（みそぎ）",
          "湯垢離（ゆごり）",
          "湯祓（ゆばらい）"
        ],
        correctAnswer: 0,
        explanation: "祭場の中心に据えた釜で湯を沸かし、笹の葉などでその熱湯を自身や周囲に振りかけることで、穢れを祓い清める神事です。"
      },
      {
        id: 12,
        question: "湯立の儀式を中心とする神楽は、ある神宮で行われたことから特定の系統に分類されることがある。その神宮はどこか。",
        options: [
          "鹿島神宮",
          "宇佐神宮",
          "伊勢神宮",
          "出雲大社"
        ],
        correctAnswer: 2,
        explanation: "湯立神事は、伊勢神宮の外宮で行われたことから「伊勢系神楽」と分類されることがあります。この儀式は、愛知県や長野県などの霜月神楽にも見られます。"
      },
      {
        id: 13,
        question: "西米良村の銀鏡神楽において、祭りの始めに祭壇に供えられる猪の頭の供物を、特に何と呼ぶか。",
        options: [
          "ミケ",
          "ニエ",
          "オニエ",
          "タテ"
        ],
        correctAnswer: 2,
        explanation: "銀鏡神楽では、祭りの始めに祭壇に猪の頭が供えられます。これは供物＝贄（にえ）であり、特に「オニエ」と呼ばれます。山の恵みへの感謝と、獣害の慰撫という両義的な意味合いを持ちます。"
      },
      {
        id: 14,
        question: "銀鏡神楽の演目「ししとぎり」では、何に関する独特の言葉や神事が語られるか。",
        options: [
          "稲作儀礼",
          "狩猟文化",
          "養蚕技術",
          "鍛冶神事"
        ],
        correctAnswer: 1,
        explanation: "銀鏡神楽の演目「ししとぎり」では、猪を狩る際の独特の狩言葉や狩猟の方法、それに関わる神事が語られ、山と共に生きた人々の文化を今に伝えています。"
      },
      {
        id: 15,
        question: "日南市北郷町の潮嶽神社で奉納される潮嶽神楽は、全国でも唯一とされるある神を主祭神としている。その神は誰か。",
        options: [
          "瓊瓊杵尊（ににぎのみこと）",
          "山幸彦（やまさちひこ）",
          "海幸彦（うみさちひこ）",
          "豊玉姫命（とよたまひめのみこと）"
        ],
        correctAnswer: 2,
        explanation: "潮嶽神社は、神話において弟の山幸彦に敗れた兄・海幸彦を主祭神とする、全国でも唯一の神社です。これは、地域の歴史や文化が、一般的な神話の解釈とは異なる独自の形で継承されていることを示しています。"
      },
      {
        id: 16,
        question: "潮嶽神楽において、海幸山幸神話を唱えながら鯛を付けた釣り竿を操る特色ある舞の名称は何か。",
        options: [
          "大漁舞",
          "魚釣舞",
          "龍神舞",
          "恵比寿舞"
        ],
        correctAnswer: 1,
        explanation: "潮嶽神楽の「魚釣舞」は、主祭神である海幸彦の物語を象徴する舞です。釣り竿を巧みに操りながら、海幸山幸神話を唱えるという特色ある演目となっています。"
      },
      {
        id: 17,
        question: "宮崎県の神楽は、県央部を境に、県北部の「冬神楽・夜神楽」と、県南部の神楽の形態に大別される。県南部の神楽の形態として正しい組み合わせはどれか。",
        options: [
          "秋神楽・半夜神楽",
          "夏神楽・朝神楽",
          "春神楽・昼神楽",
          "盆神楽・宵神楽"
        ],
        correctAnswer: 2,
        explanation: "県央を境に、県南部では5月頃まで続く「春神楽」が中心となります。これらの多くは、午前中から夕方にかけて行われる「昼神楽」です。"
      },
      {
        id: 18,
        question: "神楽の舞は、手に何も持たずに舞う「徒手（としゅ）の舞」と、鈴や扇、幣などを持って舞う「採物舞（とりものまい）」、そして面を着けて舞う舞に分類される。面を着けた舞を何と呼ぶか。",
        options: [
          "着面（ちゃくめん）の舞",
          "神面（しんめん）の舞",
          "仮面（かめん）舞",
          "鬼面（きめん）の舞"
        ],
        correctAnswer: 2,
        explanation: "神々や鬼神などを表す面を着けて舞う神楽を「仮面舞」と呼びます。採物舞と仮面舞の組み合わせは、九州の神楽の大きな特徴の一つです。"
      },
      {
        id: 19,
        question: "高千穂の夜神楽において、深夜に舞われ、男女二神の抱擁などを通じて生命の増殖を表す演目は何か。",
        options: [
          "住吉",
          "御神体",
          "五穀",
          "大神"
        ],
        correctAnswer: 1,
        explanation: "「御神体」は、イザナギ・イザナミの二神が登場し、国生み神話を演じます。生命の誕生や五穀豊穣を祈願する、夜神楽の中でも重要な演目です。"
      },
      {
        id: 20,
        question: "県西部の高原町で奉納される祓川神楽は、12月に夜を徹して行われる。これは宮崎県の神楽の分類上、どれに該当するか。",
        options: [
          "春神楽・昼神楽",
          "冬神楽・夜神楽",
          "春神楽・半夜神楽",
          "冬神楽・昼神楽"
        ],
        correctAnswer: 1,
        explanation: "高原町の祓川神楽は、12月に夜を徹して奉納されます。これは県北部の神楽と同様に、冬の農閑期に行われる夜通しの儀式であり、「冬神楽・夜神楽」に分類されます。"
      }
    ]
  },
  {
    id: 3,
    title: "セット3: 祭りの賑わい",
    category: "祭り",
    questions: [
      {
        id: 21,
        question: "毎年秋に宮崎神宮で行われる大祭は、宮崎県民に親しみを込めて何と呼ばれているか。",
        options: [
          "みやざき様",
          "神武さま",
          "大宮様",
          "天皇さま"
        ],
        correctAnswer: 1,
        explanation: "宮崎神宮の御祭神である神武天皇にちなみ、宮崎神宮大祭は県民から「神武さま」と呼ばれ、長年親しまれています。"
      },
      {
        id: 22,
        question: "「神武さま」の御神幸行列で見られる「シャンシャン馬」は、元々どのような風習を再現したものか。",
        options: [
          "藩主が江戸へ参勤交代する様子",
          "花嫁を馬に乗せて鵜戸神宮に参拝していた新婚道中",
          "古代の天皇が禊を行うために海岸へ向かう行列",
          "豊作を感謝して初穂を神社へ奉納する農民の行列"
        ],
        correctAnswer: 1,
        explanation: "「シャンシャン馬」は、かつて新婚の夫婦が、花嫁を飾り立てた馬に乗せ、鵜戸神宮へ安産や夫婦円満を祈願して参拝した「鵜戸さん参り」の道中を再現したものです。"
      },
      {
        id: 23,
        question: "日南市の秋を彩る「飫肥城下まつり」のパレードの冒頭を飾る郷土芸能は何か。",
        options: [
          "棒踊り",
          "臼太鼓踊り",
          "泰平踊",
          "ひょっとこ踊り"
        ],
        correctAnswer: 2,
        explanation: "飫肥城下まつりのパレードは、郷土芸能である「泰平踊」で幕を開けます。優雅な踊りが、城下町の祭りの始まりを告げます。"
      },
      {
        id: 24,
        question: "「泰平踊」を踊る人々は、どの時代の「伊達姿」と呼ばれる優雅な衣装を身にまとっているか。",
        options: [
          "平安時代",
          "鎌倉時代",
          "安土桃山時代",
          "元禄時代"
        ],
        correctAnswer: 3,
        explanation: "泰平踊の踊り手は、江戸時代の元禄期に流行した、華やかで粋な「伊達姿」の衣装を身にまといます。これは、飫肥藩の文化的な豊かさを象徴しています。"
      },
      {
        id: 25,
        question: "今や宮崎を代表する夏祭りとなった「日向ひょっとこ夏祭り」の踊りの起源は、明治時代にある人物が江戸の里神楽を参考に始めたことによる。その人物は誰か。",
        options: [
          "小村寿太郎",
          "高木兼寛",
          "橘公行",
          "安井息軒"
        ],
        correctAnswer: 2,
        explanation: "日向ひょっとこ踊りは、明治時代に眼科医であった橘公行が、旅先の江戸で見た里神楽の「もどき」というコミカルな演目に着想を得て、自身の開業地で踊り始めたのが起源とされます。"
      },
      {
        id: 26,
        question: "「日向ひょっとこ踊り」を創始した橘公行の職業は何であったか。",
        options: [
          "神職",
          "船大工",
          "眼科医",
          "歌舞伎役者"
        ],
        correctAnswer: 2,
        explanation: "創始者の橘公行は、地域の医療を担う眼科医でした。専門職の人物が地域文化の新たな担い手となった興味深い事例です。"
      },
      {
        id: 27,
        question: "串間市の都井岬で夏に行われる「都井岬火まつり」は、ある伝説に基づいている。その伝説とは、衛徳坊という僧侶が何を退治したというものか。",
        options: [
          "巨大な猪",
          "人食い熊",
          "大蛇",
          "悪鬼"
        ],
        correctAnswer: 2,
        explanation: "都井岬火まつりは、かつて都井神社に住み着いた大蛇を、衛徳坊（えいとくぼう）という僧侶が火を用いて退治したという伝説に由来します。"
      },
      {
        id: 28,
        question: "「都井岬火まつり」では、伝説の大蛇に見立てた約30メートルの柱の先端にあるものに点火するために、参加者が松明を投げ入れる。その柱の名称は何か。",
        options: [
          "柱松",
          "蛇柱",
          "炎柱",
          "龍松"
        ],
        correctAnswer: 0,
        explanation: "祭りのクライマックスでは、大蛇に見立てた高さ約30メートルの「柱松」に、参加者が燃え盛る松明を投げ入れ、先端の花火に点火します。"
      },
      {
        id: 29,
        question: "西都市の西都原古墳群を舞台に開催される「西都古墳まつり」の最大の見どころで、一般参加も可能なイベントは何か。",
        options: [
          "流鏑馬（やぶさめ）",
          "古代船競争",
          "たいまつ行列",
          "曲水の宴"
        ],
        correctAnswer: 2,
        explanation: "古代衣装をまとった約500名の人々が、燃え盛るたいまつを手に古墳群を練り歩く「たいまつ行列」は、幻想的で壮大な光景を作り出し、祭りのハイライトとなっています。"
      },
      {
        id: 30,
        question: "「西都古墳まつり」のたいまつ行列は、古代衣装をまとった人々が日向神話ゆかりの地をつなぐ約4kmの道を歩く。この道の名称は何か。",
        options: [
          "神話の道",
          "記紀の道",
          "天孫降臨の道",
          "古墳の道"
        ],
        correctAnswer: 1,
        explanation: "たいまつ行列が歩く約4kmのルートは、古事記や日本書紀に記された日向神話ゆかりの地を結ぶことから「記紀の道」と名付けられています。"
      }
    ]
  },
  {
    id: 4,
    title: "セット4: 食の匠と味（チキン南蛮・冷や汁）",
    category: "食文化",
    questions: [
      {
        id: 31,
        question: "宮崎名物「チキン南蛮」のルーツは、延岡市にあった洋食店「ロンドン」のまかない料理とされる。そのスタイルを受け継ぐ2つの元祖の店として知られるのは、「直ちゃん」とどこか。",
        options: [
          "味のおぐら",
          "一平寿司",
          "風月堂",
          "元祖おび天本舗"
        ],
        correctAnswer: 0,
        explanation: "チキン南蛮の元祖とされる店は二つあり、どちらも延岡の洋食店「ロンドン」で修行した人物が開いた。甘酢ダレのみのスタイルを継承するのが「直ちゃん」、タルタルソースをかけたのが「味のおぐら」です。"
      },
      {
        id: 32,
        question: "現在全国的に広まっている、タルタルソースをかけたスタイルの「チキン南蛮」を考案し、提供を始めた店はどこか。",
        options: [
          "直ちゃん",
          "ロンドン",
          "味のおぐら",
          "なんばん亭"
        ],
        correctAnswer: 2,
        explanation: "洋食店「ロンドン」のまかない料理であった甘酢ダレの鶏肉に、創業者・甲斐義光氏が独自のタルタルソースをかけて提供したのが「味のおぐら」であり、これが現在の主流スタイルの発祥となりました。"
      },
      {
        id: 33,
        question: "「味のおぐら」の創業者、甲斐義光氏がメニューにチキン南蛮を加えたのは、記録によると昭和何年か。",
        options: [
          "昭和28年 (1953)",
          "昭和34年 (1959)",
          "昭和40年 (1965)",
          "昭和45年 (1970)"
        ],
        correctAnswer: 1,
        explanation: "「味のおぐら」の記録によると、チキン南蛮が正式なメニューとして登場したのは昭和34年。その後、昭和40年頃から人気が出始めたとされます。"
      },
      {
        id: 34,
        question: "チキン南蛮が元々、鶏のある部位をおいしく食べるために考案されたという経緯がある。その部位はどこか。",
        options: [
          "もも肉",
          "むね肉",
          "ささみ",
          "手羽先"
        ],
        correctAnswer: 1,
        explanation: "当時、ジューシーなもも肉に比べてパサつきがちで余ることが多かったむね肉を、いかにおいしく食べるかという工夫からチキン南蛮は生まれました。揚げることでジューシーさを閉じ込め、甘酢で味を染み込ませる調理法は、むね肉に適していました。"
      },
      {
        id: 35,
        question: "宮崎の郷土料理「冷や汁」は、どのような人々の間で、夏の労働の合間に素早く栄養補給をするための食事として発展したか。",
        options: [
          "役人や武士",
          "商人や職人",
          "僧侶や神官",
          "農民や漁師"
        ],
        correctAnswer: 3,
        explanation: "冷や汁は、夏の暑い時期の農作業や漁の合間に、時間をかけずに簡単に作れ、食欲がなくてもかき込める栄養豊富な食事として、働く人々の中で自然発生的に生まれた料理です。"
      },
      {
        id: 36,
        question: "「鎌倉管領家記録」という書物には、冷や汁の原型ともいえる料理に関する記述がある。それによると、当時、冷や汁を食べていたのは主にどのような人々であったか。",
        options: [
          "武家",
          "僧侶",
          "公家",
          "農民"
        ],
        correctAnswer: 1,
        explanation: "「鎌倉管領家記録」には「武家にては飯に汁かけ参らせ候、僧侶にては冷汁をかけ参らせ候」との記述があり、冷や汁の原型が僧侶の間で食されていた可能性を示唆しています。"
      },
      {
        id: 37,
        question: "宮崎の冷や汁が、古い時代の原型に近い形で現在に伝わった理由として、何が考えられているか。",
        options: [
          "藩がレシピを厳格に管理していたため",
          "交通が不便で、他地域の食文化の影響を受けにくかったため",
          "神社への供物として、古来の製法が守られてきたため",
          "著名な料理人が書物に記録を残していたため"
        ],
        correctAnswer: 1,
        explanation: "僧侶によって全国に広まったとされる冷や汁は、ほとんどの地域で廃れましたが、宮崎では険しい山々によって他地域との交流が限られていたため、古い時代の食文化がそのままの形で保存されたと考えられています。"
      },
      {
        id: 38,
        question: "日南市飫肥地方の郷土料理「おび天」は、魚のすり身に豆腐などを混ぜて揚げたものだが、さつま揚げとは異なる独特の甘みが特徴である。この甘みの主な源となる材料は何か。",
        options: [
          "白砂糖",
          "蜂蜜",
          "黒砂糖",
          "水飴"
        ],
        correctAnswer: 2,
        explanation: "おび天の甘みは、主に黒砂糖によるものです。魚のすり身、豆腐、味噌に黒砂糖が加わることで、他にはない独特の風味とコクが生まれます。"
      },
      {
        id: 39,
        question: "「おび天」に黒砂糖と味噌が使われるようになった背景には、19世紀半ばに飫肥周辺で始まったある作物の栽培が関係していると考えられている。その作物は何か。",
        options: [
          "茶",
          "煙草",
          "サトウキビ",
          "綿花"
        ],
        correctAnswer: 2,
        explanation: "19世紀半ば、飫肥周辺でサトウキビ栽培が始まったことが、地域で豊富に手に入る黒砂糖をおび天に使う食文化が誕生した背景にあると考えられています。"
      },
      {
        id: 40,
        question: "今や全国的に人気の巻き寿司「レタス巻き」は、宮崎市のある寿司店が発祥である。その店の名前は何か。",
        options: [
          "寿司処 こうき",
          "鮨 ひなた",
          "一平寿司",
          "寿司虎"
        ],
        correctAnswer: 2,
        explanation: "レタス巻きは、1966年に宮崎市の「一平寿司」の初代店主、村岡正二氏によって考案されました。今では宮崎の郷土寿司として定着しています。"
      }
    ]
  },
  {
    id: 5,
    title: "セット5: 食の匠と味（スコール・チーズ饅頭）",
    category: "食文化",
    questions: [
      {
        id: 41,
        question: "「レタス巻き」は、初代店主の村岡正二氏が、ある友人の野菜嫌いを克服させるために考案した。その友人とは誰か。",
        options: [
          "長嶋茂雄",
          "石原裕次郎",
          "平尾昌晃",
          "三船敏郎"
        ],
        correctAnswer: 2,
        explanation: "村岡氏の親しい友人で、野菜嫌いであった作曲家の平尾昌晃氏のために、「野菜をおいしく食べられる寿司」として考案されたのがレタス巻きの始まりでした。"
      },
      {
        id: 42,
        question: "レタス巻きが誕生したのは西暦何年か。",
        options: [
          "1955年",
          "1966年",
          "1972年",
          "1981年"
        ],
        correctAnswer: 1,
        explanation: "レタス巻きが誕生したのは昭和41年、西暦1966年のことです。戦後日本の食生活が洋風化していく中で生まれた、新しい発想の寿司でした。"
      },
      {
        id: 43,
        question: "宮崎の新たな銘菓「チーズ饅頭」が誕生したとされるのは、宮崎県のどの市か。",
        options: [
          "宮崎市",
          "都城市",
          "延岡市",
          "小林市"
        ],
        correctAnswer: 3,
        explanation: "クッキーやスコーンのような生地でクリームチーズを包んだ「チーズ饅頭」は、1986年頃に宮崎県小林市の菓子職人によって考案されたとされる、比較的新しい宮崎銘菓です。"
      },
      {
        id: 44,
        question: "チーズ饅頭が考案されたのは、およそ何年頃か。",
        options: [
          "1975年",
          "1986年",
          "1993年",
          "2001年"
        ],
        correctAnswer: 1,
        explanation: "チーズ饅頭は、1986年に小林市の菓子職人・伊藤光輝氏が考案したとされます。洋菓子の要素を取り入れた和洋折衷の菓子として誕生しました。"
      },
      {
        id: 45,
        question: "小林市で「元祖」を名乗るチーズ饅頭の店の一つで、スコーンのようなサクサクした生地が特徴の店はどこか。",
        options: [
          "南国屋今門",
          "菓子処わらべ",
          "風月堂",
          "お菓子の日高"
        ],
        correctAnswer: 2,
        explanation: "小林市にある「元祖」を名乗る店の一つ「風月堂」のチーズ饅頭は、皮がスコーン生地で作られており、サクサクとした食感が特徴です。"
      },
      {
        id: 46,
        question: "1972年に発売され、宮崎県民のソウルドリンクとして長年愛されているヨーグルト風味の炭酸飲料の名前は何か。",
        options: [
          "ヨーグルッペ",
          "デーリィコーヒー",
          "スコール",
          "サンAドリンク"
        ],
        correctAnswer: 2,
        explanation: "南日本酪農協同が1972年に発売した「スコール」は、牛乳を原料としたヨーグルト風味の炭酸飲料で、宮崎県を代表するローカルドリンクです。"
      },
      {
        id: 47,
        question: "「スコール」という商品名は、ある国の言葉で「乾杯」を意味する。どこの国の言葉か。",
        options: [
          "ドイツ語",
          "フランス語",
          "デンマーク語",
          "オランダ語"
        ],
        correctAnswer: 2,
        explanation: "「スコール（Skal）」は、デンマーク語で「乾杯」を意味します。世界中の人々に愛される飲み物になってほしいという願いが込められています。"
      },
      {
        id: 48,
        question: "「愛のスコール」というキャッチフレーズの「愛」に込められた意味として、乳業メーカーの願いと、甘酸っぱい口当たりが連想させるものの組み合わせで正しいのはどれか。",
        options: [
          "「健康への願い」と「母の愛」",
          "「多くの人に牛乳を飲んでほしいという願い」と「初恋」",
          "「郷土への願い」と「家族愛」",
          "「子どもたちの成長への願い」と「友情」"
        ],
        correctAnswer: 1,
        explanation: "キャッチフレーズの「愛」には、乳業メーカーとして多くの人に牛乳を飲んでほしいという「願い＝愛」と、その甘酸っぱい味が「初恋＝愛」を連想させるという二つの意味が込められています。"
      },
      {
        id: 49,
        question: "「スコール」を製造・販売している、都城市に本社を置く企業名は何か。",
        options: [
          "宮崎乳業協同組合",
          "南日本酪農協同株式会社",
          "九州クロレラ食品株式会社",
          "霧島乳業株式会社"
        ],
        correctAnswer: 1,
        explanation: "スコールやヨーグルッペ、デーリィ牛乳などを製造する南日本酪農協同は、宮崎県都城市に本社を置く乳業メーカーです。"
      },
      {
        id: 50,
        question: "「スコール」のロゴの背面に描かれている模様は、幸運を呼ぶ四つ葉のクローバーのイメージと、ある星座を表現している。その星座は何か。",
        options: [
          "オリオン座",
          "北斗七星",
          "みなみじゅうじ座",
          "カシオペヤ座"
        ],
        correctAnswer: 2,
        explanation: "スコールのロゴの背景模様は、南十字星を表現しています。南国宮崎の企業であることの象徴と、幸運の四つ葉のクローバーのイメージが重ねられています。"
      }
    ]
  },
  {
    id: 6,
    title: "セット6: 伝統の技と工芸",
    category: "工芸",
    questions: [
      {
        id: 51,
        question: "全国一の生産量を誇る弓「都城大弓」と、同じく全国的に有名な木刀の産地として知られる都市はどこか。",
        options: [
          "延岡市",
          "日南市",
          "都城市",
          "日向市"
        ],
        correctAnswer: 2,
        explanation: "都城市は、江戸時代から弓づくりが盛んで、現在も竹弓の全国シェアの大部分を占める「都城大弓」の産地です。また、剣道や武道で使われる木刀の生産も盛んです。"
      },
      {
        id: 52,
        question: "宮崎県の南東部、旧飫肥藩領で生産される杉は、ある特定の名称で知られている。その名称は何か。",
        options: [
          "綾杉",
          "諸塚杉",
          "飫肥杉",
          "米良杉"
        ],
        correctAnswer: 2,
        explanation: "宮崎県南東部の日南市を中心とする旧飫肥藩領で生産される杉は「飫肥杉」と呼ばれます。樹脂分を多く含み、弾力性に富み、水に強いという特徴を持ちます。"
      },
      {
        id: 53,
        question: "飫肥杉は、かつて木造船の材料として非常に重宝された。このような船用の木材を特に何と呼ぶか。",
        options: [
          "構造材",
          "弁甲材",
          "帆柱材",
          "竜骨材"
        ],
        correctAnswer: 1,
        explanation: "弁甲材とは、木造船の構造材として使われる厚い板のことです。飫肥杉はその特性から弁甲材に適しており、かつては瀬戸内や韓国にまで出荷されていました。"
      },
      {
        id: 54,
        question: "最高級の囲碁の白石の原料となるのは、日向市のお倉ヶ浜で採れるある貝である。その貝は何か。",
        options: [
          "アコヤガイ",
          "ハマグリ",
          "サザエ",
          "アワビ"
        ],
        correctAnswer: 1,
        explanation: "日向市のお倉ヶ浜で採れるスワブテ蛤という種類のハマグリは、厚みがあり、組織が緻密で硬いため、最高級の白石の原料となります。"
      },
      {
        id: 55,
        question: "日向はまぐり碁石は、貝殻の縞模様の細かさや色合いによって等級が分けられている。そのうち、最高級品とされる等級の名称は何か。",
        options: [
          "花印",
          "月印",
          "雪印",
          "星印"
        ],
        correctAnswer: 2,
        explanation: "はまぐり碁石は、貝殻の縞模様（まさ目）の美しさで等級が分けられます。縞目が全体にまっすぐ通り、きめ細やかで美しい乳白色のものが最上級の「雪印」とされます。"
      },
      {
        id: 56,
        question: "明治時代、大阪で碁石づくりの技術を学び、地元日向での「はまぐり碁石」製造を確立した人物は誰か。",
        options: [
          "黒木庄左衛門",
          "原田清吉",
          "岩切章太郎",
          "橘公行"
        ],
        correctAnswer: 1,
        explanation: "当初は大阪の碁石屋のために貝殻拾いをしていた原田清吉が、「地元日向で碁石を作りたい」と志し、大阪で修行を積んで一流の碁石工となり、日向での製造を始めました。"
      },
      {
        id: 57,
        question: "宮崎漆器を特徴づける加飾技法で、漆から作った色付きの餅状のものを薄く伸ばし、文様の形に切り取って貼り付ける技法を何というか。",
        options: [
          "螺鈿（らでん）",
          "蒔絵（まきえ）",
          "沈金（ちんきん）",
          "堆錦（ついきん）"
        ],
        correctAnswer: 3,
        explanation: "堆錦は、漆と顔料を練り合わせて作った色鮮やかなペースト状の「堆錦餅」を薄く延ばし、文様の形に切り抜いて器面に貼り付け、立体的な装飾を施す技法です。"
      },
      {
        id: 58,
        question: "宮崎漆器の堆錦の技法は、日本の別の地域の漆器の流れを汲んでいる。その地域はどこか。",
        options: [
          "輪島（石川県）",
          "津軽（青森県）",
          "琉球（沖縄県）",
          "鎌倉（神奈川県）"
        ],
        correctAnswer: 2,
        explanation: "堆錦は琉球漆器（沖縄）で発展した独自の技法であり、宮崎漆器は、この南国的な華やかさを持つ技法を取り入れている点に大きな特徴があります。"
      },
      {
        id: 59,
        question: "約400年の歴史を持つ宮崎市の伝統工芸品「佐土原人形」の代表的な作品で、幼児が饅頭を手に問い返す逸話を持つ人形の名称は何か。",
        options: [
          "饅頭喰い",
          "鯉持ち",
          "馬乗り",
          "忠臣蔵"
        ],
        correctAnswer: 0,
        explanation: "「お父さんとお母さんどっちが好き？」と問われた子どもが、手に持った饅頭を二つに割り「この饅頭はどちらが美味しい？」と問い返したという逸話に基づく人形で、佐土原人形を代表する最も有名な作品です。"
      },
      {
        id: 60,
        question: "「饅頭喰い」の人形は、元々は京都のある人形を原型としていたが、大正時代に佐土原で女の子の姿になったとされる。原型となった京都の人形は何か。",
        options: [
          "京人形",
          "御所人形",
          "伏見人形",
          "嵯峨人形"
        ],
        correctAnswer: 2,
        explanation: "京都の伏見人形に原型を持つこの人形は、元々は男の子であったが、大正時代に佐土原で髷をつけた女の子の姿が作られ、男女一対の人形として親しまれるようになりました。"
      }
    ]
  },
  {
    id: 7,
    title: "セット7: 郷土の偉人たち（若山牧水・中村地平）",
    category: "偉人",
    questions: [
      {
        id: 61,
        question: "「幾山河越えさり行かば寂しさの終てなむ国ぞ今日も旅ゆく」の歌で知られる、東臼杵郡坪谷村（現・日向市）出身の歌人は誰か。",
        options: [
          "中村地平",
          "若山牧水",
          "伊藤一彦",
          "谷口午二"
        ],
        correctAnswer: 1,
        explanation: "この歌は若山牧水の代表作の一つ。旅と酒、そして自然を愛し、その中に人間の寂しさや喜びを詠んだ作風で、近代日本を代表する歌人の一人です。"
      },
      {
        id: 62,
        question: "自然主義的な作風で知られ、生涯に9000首もの短歌を創作したとされる若山牧水の最初の歌集のタイトルは何か。",
        options: [
          "海の声",
          "路上",
          "みなかみ",
          "死か藝術か"
        ],
        correctAnswer: 0,
        explanation: "1908年に発表された処女歌集『海の声』は、恋愛を情熱的に詠んだ浪漫主義的な作品で、牧水が歌壇に鮮烈なデビューを飾るきっかけとなりました。"
      },
      {
        id: 63,
        question: "宮崎市出身で、戦前の台湾を舞台にした作品を多く執筆し、「南方文学」というジャンルを確立した作家は誰か。",
        options: [
          "火野葦平",
          "中村地平",
          "梅崎春生",
          "島尾敏雄"
        ],
        correctAnswer: 1,
        explanation: "中村地平は、自身の台湾での体験をもとに、南国の自然や人々をロマンティックかつ独特の視点で描いた。「南方への郷愁」をテーマとし、独自の文学世界を築きました。"
      },
      {
        id: 64,
        question: "中村地平の「南方文学」は、彼の南方への憧憬やロマン主義だけでなく、当時の日本が推進していたある国策と巧妙に結びついていた側面がある。その国策とは何か。",
        options: [
          "富国強兵",
          "殖産興業",
          "南進政策",
          "大東亜共栄圏構想"
        ],
        correctAnswer: 3,
        explanation: "中村地平の1939年以降の作品は、日本の帝国主義的な南進政策と呼応するように、未開の「南方」を日本が文明化すべき対象として描く傾向が見られます。これは彼の文学の複雑な側面を示しています。"
      },
      {
        id: 65,
        question: "江戸時代後期の儒学者で、清武町（現・宮崎市）出身の安井息軒が、江戸に開いた私塾の名前は何か。",
        options: [
          "咸宜園（かんぎえん）",
          "松下村塾（しょうかそんじゅく）",
          "三計塾（さんけいじゅく）",
          "適塾（てきじゅく）"
        ],
        correctAnswer: 2,
        explanation: "安井息軒は天保10年（1839年）に江戸麹町に「三計塾」を開き、幕末の動乱期に向けて多くの人材を育成しました。"
      },
      {
        id: 66,
        question: "安井息軒が塾の名前にした「三計」とは、「一日の計は朝にあり」「一年の計は春にあり」と、あと一つは何を指すか。",
        options: [
          "一生の計は壮年にあり",
          "一生の計は少壮の時にあり",
          "一生の計は勤勉にあり",
          "一生の計は健康にあり"
        ],
        correctAnswer: 1,
        explanation: "「三計」とは、物事の始まりが肝心であるという教え。「一日の計は朝に」「一年の計は春（元旦）に」「一生の計は若いうちに」計画を立て、実行すべきだという教訓です。"
      },
      {
        id: 67,
        question: "西都市出身の画家・塩月桃甫は、戦前の日本統治時代のある地域に渡り、西洋美術の普及に大きく貢献した。その地域はどこか。",
        options: [
          "満州",
          "台湾",
          "樺太",
          "朝鮮"
        ],
        correctAnswer: 1,
        explanation: "塩月桃甫は、大正10年（1921年）に日本政府側の教育者として台湾に渡り、以降、台湾の美術教育の基礎を築き、多くの画家に影響を与えました。"
      },
      {
        id: 68,
        question: "塩月桃甫が台湾の美術界に残した最も大きな功績の一つは、ある展覧会を創設したことである。その展覧会は何か。",
        options: [
          "台湾総督府美術展覧会",
          "帝国美術院展覧会台湾支部展",
          "台湾美術展覧会",
          "台北アール・デコ展覧会"
        ],
        correctAnswer: 2,
        explanation: "塩月桃甫は、台湾で初めての官設美術展覧会である「台湾美術展覧会（台展）」の創設に尽力し、台湾の芸術家たちに発表の場を与え、台湾近代美術の発展に多大な貢献をしました。"
      },
      {
        id: 69,
        question: "宮崎市出身で、写真の印画紙と光を用いてイメージを作り出す「フォト・デッサン」という独自の手法を編み出し、日本の前衛美術の先駆者となった芸術家は誰か。",
        options: [
          "杉田秀夫",
          "瑛九",
          "山田正平",
          "塩月桃甫"
        ],
        correctAnswer: 1,
        explanation: "瑛九（本名：杉田秀夫）は、カメラを使わず、印画紙の上に直接物を置いたり光を当てたりしてイメージを作り出す「フォト・デッサン」を1936年に発表し、美術界に衝撃を与えました。"
      },
      {
        id: 70,
        question: "瑛九が「フォト・デッサン」の手法による作品集を初めて刊行した際のタイトルは何か。",
        options: [
          "眠りの理由",
          "光の戯れ",
          "影の詩",
          "田園の憂鬱"
        ],
        correctAnswer: 0,
        explanation: "瑛九は、この新しい表現方法による作品をまとめ、写真集『眠りの理由』として刊行しました。これが彼の芸術家としての出発点となりました。"
      }
    ]
  },
  {
    id: 8,
    title: "セット8: 郷土の偉人たち（石井十次・塩月桃甫）",
    category: "偉人",
    questions: [
      {
        id: 71,
        question: "高鍋町出身で、「児童福祉の父」と称され、岡山で大規模な孤児院を創設・運営した社会事業家は誰か。",
        options: [
          "賀川豊彦",
          "留岡幸助",
          "山室軍平",
          "石井十次"
        ],
        correctAnswer: 3,
        explanation: "宮崎県高鍋町出身の石井十次は、キリスト教精神に基づき、明治20年（1887年）に岡山市で孤児院を創設。日本における児童福祉の先駆者として、その生涯を孤児救済に捧げました。"
      },
      {
        id: 72,
        question: "石井十次が創設した岡山孤児院は、ある主義のもと、地域の区別なく孤児を受け入れ、最盛期には1200名もの子どもたちを保護した。その主義とは何か。",
        options: [
          "選別収容主義",
          "無制限収容主義",
          "地域限定収容主義",
          "縁故者優先主義"
        ],
        correctAnswer: 1,
        explanation: "石井十次の岡山孤児院は、定員を設けず、頼ってくる子どもは誰でも受け入れるという「無制限収容主義」を掲げていました。これは彼の深い博愛精神を象徴する方針でした。"
      },
      {
        id: 73,
        question: "瑛九が、因習的な画壇を嫌い、自由と独立の精神での制作を目指して、池田満寿夫や靉嘔らと共に結成した美術家団体の名称は何か。",
        options: [
          "自由美術家協会",
          "デモクラート美術家協会",
          "具体美術協会",
          "美術文化協会"
        ],
        correctAnswer: 1,
        explanation: "1951年、瑛九は「すべての美術家は自由な発表の場を求め、かつ、その創造に於て自由でなければならない」という理念のもと、同志と共に「デモクラート美術家協会」を結成しました。"
      },
      {
        id: 74,
        question: "若山牧水は歌人としてだけでなく、ある分野でも才能を発揮した。それは何か。",
        options: [
          "彫刻家",
          "書家",
          "作曲家",
          "陶芸家"
        ],
        correctAnswer: 1,
        explanation: "若山牧水は、自作の短歌を毛筆で書き記した作品を数多く残しており、その流麗で力強い書は高く評価されています。歌人であると同時に、優れた書家としての一面も持っていました。"
      },
      {
        id: 75,
        question: "塩月桃甫は、台湾のどのような人々の姿や文化に魅せられ、大胆なタッチと色使いで描き続けたか。",
        options: [
          "都市部の知識人",
          "茶畑で働く農民",
          "港町の商人",
          "先住民族"
        ],
        correctAnswer: 3,
        explanation: "台湾に渡った塩月桃甫は、特に台湾の先住民族の力強い生命力や独自の文化に深く魅了され、彼らの姿を主題とした作品を数多く制作しました。"
      },
      {
        id: 76,
        question: "2023年4月に開催されたG7宮崎農業大臣会合で、各国の大臣への贈呈品として選ばれた宮崎県の伝統工芸品は何か。",
        options: [
          "都城大弓",
          "日向はまぐり碁石",
          "宮崎漆器の弁当箱と箸",
          "佐土原人形"
        ],
        correctAnswer: 2,
        explanation: "G7宮崎農業大臣会合では、宮崎の伝統と食文化を象徴するものとして、宮崎漆器で作られた弁当箱と箸が各国の大臣への公式な贈呈品として選ばれました。"
      },
      {
        id: 77,
        question: "日向はまぐり碁石の原料となる貝殻の採取法のうち、昭和27年に初めて応用され、ポンプで海水と共に海底の土砂を吸い上げる最も進歩した方法は何か。",
        options: [
          "潜水採取",
          "床掘り",
          "円筒枠床掘り",
          "ポンプ船採取"
        ],
        correctAnswer: 3,
        explanation: "昭和27年に導入されたポンプ船採取法は、船上のポンプで海底の砂と海水を一緒に吸い上げ、船上で貝殻を選別する方法で、最も効率的な採取法として平成初期まで行われました。"
      },
      {
        id: 78,
        question: "佐土原人形の製法には、粘土を型に指で押し込む「手押し型」と、泥状の粘土を型に注ぎ込む方法がある。後者の方法を何というか。",
        options: [
          "流し込み型",
          "鋳込み型",
          "叩き込み型",
          "練り込み型"
        ],
        correctAnswer: 1,
        explanation: "鋳込み型は、石膏の型に泥状に溶いた粘土を流し込み、石膏が水分を吸うことで型の内側に一定の厚みの層ができた後、余分な泥を排出して成形する方法です。"
      },
      {
        id: 79,
        question: "佐土原人形の起源には諸説あるが、作り方を伝えたとされるのは、どの国の人々であったかという説があるか。",
        options: [
          "中国（明）",
          "高麗（朝鮮）",
          "オランダ",
          "ポルトガル"
        ],
        correctAnswer: 1,
        explanation: "佐土原人形の起源には諸説ありますが、約400年前、文禄・慶長の役の際に島津軍と共に渡来した高麗人から製法が伝えられたという説が有力視されています。"
      },
      {
        id: 80,
        question: "江戸時代の佐土原では、ある大衆芸能が栄え、それを題材にした佐土原人形も多く作られた。その芸能とは何か。",
        options: [
          "能楽",
          "狂言",
          "文楽",
          "歌舞伎"
        ],
        correctAnswer: 3,
        explanation: "江戸時代の城下町佐土原では「佐土原座」を中心に歌舞伎が大変栄えた。その影響で、「忠臣蔵」や「静御前と狐忠信」など、歌舞伎の一場面を題材にした人形が数多く作られました。"
      }
    ]
  },
  {
    id: 9,
    title: "セット9: 言葉、伝説、そして現代",
    category: "方言・建築",
    questions: [
      {
        id: 81,
        question: "宮崎弁を代表する言葉で、「面倒くさい」「億劫だ」といった意味合いで使われ、宮崎の県民性を表す言葉としてもしばしば引用されるのはどれか。",
        options: [
          "てげ",
          "ひんだれた",
          "よだきい",
          "のさん"
        ],
        correctAnswer: 2,
        explanation: "「よだきい」は、単に「疲れた」という身体的な状態だけでなく、「面倒だ」「やる気が起きない」といった精神的な億劫さも含む、ニュアンスの深い言葉です。古語の「よだけし」に由来するとされます。"
      },
      {
        id: 82,
        question: "宮崎県北部の山間部に伝わる妖怪で、峠道などで人にとり憑き、激しい空腹感を与えるとされるのは何か。",
        options: [
          "ダル",
          "ヒダル神",
          "ヒダリ神",
          "タリ"
        ],
        correctAnswer: 2,
        explanation: "「ヒダリ」とは空腹を意味する古い言葉（ひだるい）に由来します。ヒダリ神は、西日本に広く分布する俗信で、山中でこの神にとり憑かれると、急に動けなくなるほどの空腹感に襲われるといいます。"
      },
      {
        id: 83,
        question: "山仕事や猟で山に入った際、ヒダリ神を避けるために行われる風習として伝えられていることは何か。",
        options: [
          "塩をひとつまみ撒く",
          "昼食のご飯を一口分残す",
          "大きな声で歌をうたう",
          "木の枝に赤い布を結ぶ"
        ],
        correctAnswer: 1,
        explanation: "山中でヒダリ神にとり憑かれないように、あるいはとり憑かれた時のために、弁当のご飯を一口分、神への供物として残しておくという風習が伝えられています。"
      },
      {
        id: 84,
        question: "1932年に竣工した宮崎県庁本館は、昭和初期のモダンな庁舎建築として知られ、国の登録有形文化財にもなっている。その建築様式は何か。",
        options: [
          "ネオ・ルネサンス様式",
          "アール・デコ様式",
          "近世ゴシック様式",
          "バウハウス様式"
        ],
        correctAnswer: 2,
        explanation: "宮崎県庁本館は、垂直性を強調したデザインや尖頭アーチなど、ゴシック建築の要素を取り入れた「近世ゴシック様式」と呼ばれるスタイルで建てられています。これは昭和初期の庁舎建築としては珍しく、その美しさと風格で知られます。"
      },
      {
        id: 85,
        question: "宮崎県立芸術劇場のコンサートホールに設置されているパイプオルガンは、そのデザインがある古代の出土品をモチーフにしている。その出土品とは何か。",
        options: [
          "銅鐸",
          "銅鏡",
          "子持家形埴輪",
          "三角縁神獣鏡"
        ],
        correctAnswer: 2,
        explanation: "パイプオルガンの全体的なデザインは、県内の西都原古墳群から出土した、国の重要文化財である「子持家形埴輪」をモチーフとしています。古代と現代、西洋と東洋の文化が融合したデザインです。"
      },
      {
        id: 86,
        question: "パイプオルガンの回転飾りが太陽の形をしているのは、宮崎県が「日向（ひむか）の国」と呼ばれることに由来する。「ゾンネ」とは、どこの国の言葉で「太陽」を意味するか。",
        options: [
          "英語",
          "フランス語",
          "イタリア語",
          "ドイツ語"
        ],
        correctAnswer: 3,
        explanation: "ドイツ語で「星」を意味する「シュテルン」から、通常は「ツィンベルシュテルン」と呼ばれるこの回転飾りは、宮崎では「太陽」を意味する「ゾンネ」を用いて「ツィンベルゾンネ」と名付けられています。"
      },
      {
        id: 87,
        question: "宮崎県立芸術劇場のパイプオルガンには、宮崎の伝統芸能をモチーフにした、世界でここだけのユニークな音色（ストップ）が組み込まれている。その音色の名称は何か。",
        options: [
          "神楽太鼓",
          "篠笛",
          "臼太鼓",
          "チャンチキ"
        ],
        correctAnswer: 1,
        explanation: "このオルガンには66ある音色（ストップ）の中に、宮崎の神楽で使われる笛の音を再現した「篠笛」ストップがあります。オルガンのパイプで日本の笛の音色を表現した、世界でも類を見ない試みです。"
      },
      {
        id: 88,
        question: "このユニークな「篠笛」の音色は、製作者がどこで手にした一本の笛から着想を得て、実験を重ねて生み出されたものか。",
        options: [
          "宮崎神宮",
          "鵜戸神宮",
          "高千穂神社",
          "都萬神社"
        ],
        correctAnswer: 2,
        explanation: "オルガンの製作者である須藤氏が、高千穂神社で神楽を見学した際に手にした一本の神楽笛の音色に感銘を受け、その音をパイプオルガンで再現することを目指したのが開発のきっかけとなりました。"
      },
      {
        id: 89,
        question: "宮崎県立芸術劇場のパイプオルガンは、66の音色を出すために、合計で何本のパイプが使われているか。",
        options: [
          "1,234本",
          "2,876本",
          "4,047本",
          "5,555本"
        ],
        correctAnswer: 2,
        explanation: "この壮大なパイプオルガンは、大小様々な4,047本ものパイプを駆使して、66種類の多彩な音色を奏でます。外から見えるパイプの裏側にも、無数のパイプが林立しています。"
      },
      {
        id: 90,
        question: "パイプオルガンの中央で輝く回転飾りは、通常は星の形をした「ツィンベルシュテルン」だが、宮崎にちなんで特別な形をしている。その形とは何か。",
        options: [
          "月",
          "太陽",
          "勾玉",
          "船"
        ],
        correctAnswer: 1,
        explanation: "ドイツ語で「星」を意味する「シュテルン」から、通常は「ツィンベルシュテルン」と呼ばれるこの回転飾りは、宮崎では「太陽」を意味する「ゾンネ」を用いて「ツィンベルゾンネ」と名付けられています。宮崎が「日向（ひむか）の国」と呼ばれることに由来します。"
      }
    ]
  },
  {
    id: 10,
    title: "セット10: 祭りと食文化の総合",
    category: "総合",
    questions: [
      {
        id: 91,
        question: "「西都古墳まつり」のもう一つの見どころで、神々の恋物語を舞や音楽で再現するイベントの名称は何か。",
        options: [
          "神々の饗宴",
          "炎の祭典",
          "古代の調べ",
          "愛の神話劇"
        ],
        correctAnswer: 1,
        explanation: "「炎の祭典」は、西都原古墳群を舞台に、瓊瓊杵尊と木花開耶姫の恋物語など、神々の物語を壮大な舞や音楽、そして炎の演出で再現するイベントです。"
      },
      {
        id: 92,
        question: "「神武さま」の御神幸行列に華を添える「ミスシャンシャン馬」は、毎年何名選出されるか。",
        options: [
          "2名",
          "4名",
          "8名",
          "12名"
        ],
        correctAnswer: 2,
        explanation: "毎年、宮崎県内の企業や団体から8名の女性が「ミスシャンシャン馬」として選出され、御神幸行列に華を添えます。"
      },
      {
        id: 93,
        question: "「飫肥城下まつり」のパレードでは、武者行列のほかに、人力車に乗った女性たちが登場し、祭りを盛り上げる。彼女たちの称号は何か。",
        options: [
          "ミス飫肥",
          "ミス城下町",
          "ミスお姫様",
          "ミス泰平"
        ],
        correctAnswer: 2,
        explanation: "飫肥城下まつりのパレードでは、公募で選ばれた「ミスお姫様」たちが人力車に乗り、沿道の観客に笑顔を振りまきます。"
      },
      {
        id: 94,
        question: "「日向ひょっとこ夏祭り」の踊りの原型となった江戸の里神楽の演目は、ひょっとこやおかめが登場する何と呼ばれる芸能であったか。",
        options: [
          "かぶき",
          "もどき",
          "ねり",
          "はやし"
        ],
        correctAnswer: 1,
        explanation: "ひょっとこ踊りの原型は、江戸の里神楽の中で、主役の真面目な舞の合間に登場し、滑稽な仕草で場を和ませる「もどき」と呼ばれる芸能でした。"
      },
      {
        id: 95,
        question: "「神武さま」の御神幸行列は2日間かけて行われる。初日の行列は宮崎神宮から出発し、どこを御旅所（宿泊地）とするか。",
        options: [
          "青島神社",
          "江田神社",
          "瀬頭御旅所",
          "大淀川河川敷"
        ],
        correctAnswer: 2,
        explanation: "御神幸行列の初日は、宮崎神宮を出発し、市内の橘通りなどを練り歩いた後、瀬頭にある御旅所で一泊します。翌日は逆のコースを辿って宮崎神宮へ還幸します。"
      },
      {
        id: 96,
        question: "「おぐら」のチキン南蛮は、揚げたての鶏肉を甘酢タレにくぐらせた後、たっぷりのタルタルソースをかけるのが特徴だが、鶏肉が冷めずに柔らかい食感を保つ工夫がされている。その工夫とは何か。",
        options: [
          "鶏肉を二度揚げする",
          "タルタルソースを温める",
          "甘酢タレを温めている",
          "揚げる直前に鶏肉を蒸す"
        ],
        correctAnswer: 2,
        explanation: "「おぐら」では、揚げたての鶏肉を温かい甘酢タレにくぐらせます。これにより、鶏肉が冷めることなく、またタレの味が染み込みやすくなり、むね肉でも柔らかくジューシーな食感を保つことができます。"
      },
      {
        id: 97,
        question: "宮崎の冷や汁に欠かせない薬味として、一般的に使われる香味野菜の組み合わせはどれか。",
        options: [
          "ネギとショウガ",
          "ミョウガと三つ葉",
          "大葉とキュウリ",
          "パセリとセロリ"
        ],
        correctAnswer: 2,
        explanation: "冷や汁には、焼いた味噌と魚の出汁に、豆腐、そして薬味として千切りにしたキュウリと大葉（青じそ）を入れるのが一般的です。これらが夏の食欲をそそる爽やかな風味を生み出します。"
      },
      {
        id: 98,
        question: "「おび天」は、以前は別の名称で呼ばれていた。その名称として記録に残っているものは何か。",
        options: [
          "飫肥のハンペン",
          "飫肥のカマボコ",
          "飫肥のチクワ",
          "飫肥のアブラゲ"
        ],
        correctAnswer: 3,
        explanation: "現在「おび天」として知られるこの料理は、以前は「飫肥のテンプラ」や、その形状や製法から「飫肥のアブラゲ（油揚げ）」と呼ばれていました。"
      },
      {
        id: 99,
        question: "レタス巻きの具材として、レタスと共に巻かれる主役の食材は何か。",
        options: [
          "マグロ",
          "アボカド",
          "エビ",
          "鶏のささみ"
        ],
        correctAnswer: 2,
        explanation: "元祖レタス巻きの具材は、シャキシャキのレタスとプリプリの茹でエビ、そしてそれらをまとめるマヨネーズです。"
      },
      {
        id: 100,
        question: "「おび天」は、魚のすり身の他に、ある材料を混ぜ込むことで、ふっくらとした食感を生み出している。その材料は何か。",
        options: [
          "卵",
          "山芋",
          "豆腐",
          "片栗粉"
        ],
        correctAnswer: 2,
        explanation: "おび天は、魚のすり身に崩した豆腐を混ぜ込むのが大きな特徴です。これにより、揚げても硬くならず、ふっくらとした独特の食感が生まれます。"
      }
    ]
  }
];

// 全クイズデータを1つの配列にまとめたもの（既存のコードとの互換性のため）
export const allQuizData = quizSets.flatMap(set => set.questions);
